import { Component, OnInit, OnDestroy, Input, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs';
import { select } from '@ptl/angular-redux-store';
import {
  DRXRetailAndMailCosts,
  DRXMonthlyCosts
} from 'src/app/shared/interfaces/drx.interface';
import { DRUG_TOGGLE_OPTIONS } from 'src/app/shared/enums/drug-costs.enum';
import { GlobalShadowStyleDirective } from '@ptl/global-components';

@Component({
    selector: 'app-total-drug-cost',
    templateUrl: './total-drug-cost.component.html',
    styleUrls: ['./total-drug-cost.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom
    /** Failed to execute 'attachShadow' on 'Element': Shadow root cannot be created on a host which already hosts a shadow tree. */
    ,
    standalone: false
})
export class TotalDrugCostComponent extends GlobalShadowStyleDirective implements OnInit, OnDestroy {
  @Input() monthlyCostDescriptionContent: string;
  @Input() coverageHeading: string;
  @Input() monthlyHeading: string;
  defaultCoverageHeading: string = 'Monthly Cost By Coverage Phase';
  defaultMonthTableHeading: string = 'Estimated Drug Cost By Month';

  @select(['componentStates', 'DrxServiceData', 'drxToggleOption'])
  retailMailOrderSwitch$: Observable<DRUG_TOGGLE_OPTIONS>;

  retailMailOrderSwitch: DRUG_TOGGLE_OPTIONS;
  hasDeductibleColumn: boolean = false;

  monthLabels = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];
  @select(['componentStates', 'DrxServiceData', 'drxMonthlyCosts', 'retail'])
  retail$: Observable<DRXMonthlyCosts>;
  @select(['componentStates', 'DrxServiceData', 'drxMonthlyCosts', 'mailOrder'])
  mailOrder$: Observable<DRXMonthlyCosts>;
  tableData: DRXRetailAndMailCosts = {
    retail: null,
    mailOrder: null
  };
  
  constructor() {
    super();
    this.retail$.subscribe((val) => {
      this.tableData.retail = val;
      this.updateDeductibleColumn();
    });

    this.mailOrder$.subscribe((val) => {
      this.tableData.mailOrder = val;
      this.updateDeductibleColumn();
    });

    this.retailMailOrderSwitch$.subscribe((val) => {
      this.retailMailOrderSwitch = val;
      this.updateDeductibleColumn();
    });
  }

  async ngOnInit() {
  }

  updateDeductibleColumn() {
    let columnNames = this.tableData?.[this.retailMailOrderSwitch]?.monthlyAfterDeductible?.headerRow;

    if (columnNames) {
      this.hasDeductibleColumn = columnNames.filter((name) => name.toLowerCase() === 'deductible').length > 0;
    }
    else {
      this.hasDeductibleColumn = false;
    }
  }

  ngOnDestroy() {}
}
